import React from 'react';
import ReactDOM from 'react-dom';
import { getApplication, filterApplicationPage }  from './services/plugin-service/plugin-url-service';

const App = getApplication(filterApplicationPage());

ReactDOM.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>,
    document.getElementById('root'),
);
